var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGasStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg_icon",
    viewBox: "0 0 24.9 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243A53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.2,1.8,21,4H18V7.4a3.5,3.5,0,0,0,3.5,3.4h1.4v7.8A1.4,1.4,0,0,1,21.5,20,1.5,1.5,0,0,1,20,18.6v-.5a3.5,3.5,0,0,0-3.4-3.5H14.1V3.4A3.4,3.4,0,0,0,10.7,0H3.4A3.4,3.4,0,0,0,0,3.4V18.6A3.4,3.4,0,0,0,3.4,22h7.3a3.4,3.4,0,0,0,3.4-3.4v-2h2.5A1.5,1.5,0,0,1,18,18.1v.5A3.5,3.5,0,0,0,21.5,22a3.4,3.4,0,0,0,3.4-3.4V4.5L19.4.2ZM3.4,2h7.3a1.4,1.4,0,0,1,1.4,1.4v3H2v-3A1.4,1.4,0,0,1,3.4,2Zm7.3,18H3.4A1.4,1.4,0,0,1,2,18.6V8.4H12.1V18.6A1.4,1.4,0,0,1,10.7,20ZM21.5,8.8A1.5,1.5,0,0,1,20,7.4V6h2.9V8.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGasStation);
export default __webpack_public_path__ + "static/media/icon-gas-station.eebefcdb0f5c3ccfb72a301b7e8bc764.svg";
export { ForwardRef as ReactComponent };